const getIndentationMultiplier = ({
  isCollapsed,
  isIndentationDisabled,
  hasOnlyLastMessage,
  parentMsgsLength,
}: {
  isCollapsed: boolean;
  hasOnlyLastMessage: boolean;
  parentMsgsLength: number;
  isIndentationDisabled: boolean;
}) => {
  if (hasOnlyLastMessage || isIndentationDisabled) {
    return 0;
  }

  if (isCollapsed) {
    return 1;
  } else {
    return parentMsgsLength;
  }
};

export default getIndentationMultiplier;
